import React from 'react'
import styled from 'styled-components'
import ReactTags from 'react-tag-autocomplete'

export const GlobalSearchUnstyled = ({
  suggestions,
  tags,
  className,
  onSelectTag,
  onRemoveTag,
  // ReactTags doesn't seem to support a way of passing this in which means
  // we can't make it a controlled component :(
  value,
  onInput,
}) => (
  <div className={className}>
    <ReactTags
      tags={tags.map(s => ({ id: s, name: s }))}
      suggestions={suggestions.map(s => ({ id: s, name: s }))}
      handleDelete={handleDelete.bind(this, tags, onRemoveTag)}
      handleAddition={handleAddition.bind(null, suggestions, onSelectTag)}
      placeholder="Search for anything"
      handleInputChange={onInput}
    />
  </div>
)

const handleAddition = (suggestions, onSelectTag, { id, name }) =>
  onSelectTag(
    // Note if two tags have the same description this will only match the
    // first
    //suggestions.find(s => s.label == name)
    id,
  )

const handleDelete = (tags, onRemoveTag, index) => onRemoveTag(tags[index])

const GlobalSearch = styled(GlobalSearchUnstyled)`
  .react-tags {
    position: relative;
    font-size: 16px;
    line-height: 24px;
    display: inline-block;
    transition: height 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    border: none;
    border-radius: 4px;
    background: #ffffff;
    box-sizing: border-box;
    padding: 10px 20px;
    border: none;
    font-family: monospace;

    /* clicking anywhere will focus the input */
    cursor: text;
  }

  .react-tags.is-focused {
  }

  .react-tags__selected {
    display: inline;
  }

  .react-tags__selected-tag {
    display: inline-block;
    box-sizing: border-box;
    margin: 0 6px 6px 0;
    padding: 6px 8px;
    border-radius: 4px;
    background: #7f8fa4;
    color: white;
    border: none;

    /* match the font styles */
    font-size: inherit;
    line-height: inherit;
  }

  .react-tags__selected-tag:after {
    content: '\\2715';
    color: #ffffff;
    margin-left: 8px;
  }

  .react-tags__selected-tag:hover,
  .react-tags__selected-tag:focus {
  }

  .react-tags__search {
    display: inline-block;

    /* match tag layout */
    padding: 7px 2px;
    margin-bottom: 6px;

    /* prevent autoresize overflowing the container */
    max-width: 100%;
  }

  @media screen and (min-width: 30em) {
    .react-tags__search {
      /* this will become the offsetParent for suggestions */
      position: relative;
    }
  }

  .react-tags__search input {
    /* prevent autoresize overflowing the container */
    max-width: 100%;

    /* remove styles and layout from this element */
    margin: 0;
    padding: 0;
    border: 0;
    outline: none;

    /* match the font styles */
    font-size: inherit;
    line-height: inherit;
  }

  .react-tags__search input::-ms-clear {
    display: none;
  }

  .react-tags__suggestions {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 10;
  }

  @media screen and (min-width: 30em) {
    .react-tags__suggestions {
      width: 240px;
    }
  }

  .react-tags__suggestions ul {
    margin: 4px -1px;
    padding: 0;
    list-style: none;
    background: white;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .react-tags__suggestions li {
    border-bottom: 1px solid #ddd;
    padding: 6px 8px;
  }

  .react-tags__suggestions li mark {
    text-decoration: underline;
    background: none;
    font-weight: 600;
  }

  .react-tags__suggestions li:hover {
    cursor: pointer;
    background: #eee;
  }

  .react-tags__suggestions li.is-active {
    background: #b7cfe0;
  }

  .react-tags__suggestions li.is-disabled {
    opacity: 0.5;
    cursor: auto;
  }
`

export default GlobalSearch
